import React from 'react';
import { TimePicker } from 'antd';
import PropTypes from 'prop-types';
import { width } from 'styled-system';
import styled from 'styled-components';

const StyledTimeRangePicker = styled(TimePicker.RangePicker)`
  ${width};
  width: 100%;
`;

export function TimeRangePickerControl({ settings, name, onChange, onBlur, ...props }) {
  return (
    <StyledTimeRangePicker
      allowClear={false}
      name={name}
      onChange={range => onChange({ target: { name, value: range } })}
      onBlur={() => onBlur({ target: { name } })}
      {...settings}
      {...props}
    />
  );
}

TimeRangePickerControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
